import { TWidget, TWidgetData } from 'utility/types/dataProvider';
import { TBubbleChartData } from './BubbleChart';

export const mapBubbleChartData = ({
  config,
  data,
  scale,
}: {
  config: TWidget['config'];
  data: TWidgetData;
  scale?: Function; // d3.scaleLinear().domain([0, 100]).range([5, 50]);
}): TBubbleChartData[] | [] => {
  if (!config || !data?.results?.length) return [];

  const labelKey = config?.label || 'keyword';
  const valueKey = config?.value || 'views';

  return data?.results?.map((datapoint: Record<string, any>) => {
    return {
      label: datapoint?.[labelKey] || 'Unknown',
      value: datapoint?.[valueKey] || 0,
      cluster: '',
      radius: scale?.(datapoint?.[valueKey] || 0) ?? 0,
    };
  });
};
